<template>
  <ai-tool-tip
    :label="$t('error.tooltip.label')"
    variant="warning"
    align="left"
    align-item="center"
    background="red-100"
    icon-fill="red-700">
    <ai-typo
      variant="button-regular"
      as="button"
      class="AiErrorToolTip-button"
      @click="onRefresh">
      {{ $t('error.tooltip.refresh') }}
    </ai-typo>
  </ai-tool-tip>
</template>

<script setup lang="ts">
function onRefresh() {
  window.location.reload();
}
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';

.AiErrorToolTip-button {
  margin-top: constants.$inner-01;
  text-transform: uppercase;
  text-decoration: underline;
}
</style>
